import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar" }




export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
    header: {},
    titlePos: { default: 'center' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "left"),
    _createElementVNode("h2", {
      class: "page-title",
      style: _normalizeStyle({ textAlign: _ctx.titlePos })
    }, _toDisplayString(_ctx.header), 5),
    _renderSlot(_ctx.$slots, "right")
  ]))
}
}

})